import { ReceiptNumberDetails } from '../models/sale'

export function isSameReceiptDetails(
  firstReceipt: ReceiptNumberDetails | string | undefined,
  secondReceipt: ReceiptNumberDetails | string | undefined
): boolean {
  if (firstReceipt === undefined || secondReceipt === undefined) {
    return false
  }

  let convertedFirstReceipt = ''
  if (typeof firstReceipt !== 'string') {
    convertedFirstReceipt =
      firstReceipt.prefix + firstReceipt.number + firstReceipt.suffix
  } else {
    convertedFirstReceipt = firstReceipt
  }
  let convertedSecondReceipt = ''
  if (typeof secondReceipt !== 'string') {
    convertedSecondReceipt =
      secondReceipt.prefix + secondReceipt.number + secondReceipt.suffix
  } else {
    convertedSecondReceipt = secondReceipt
  }

  return convertedFirstReceipt === convertedSecondReceipt
}
